import { render, staticRenderFns } from "./task-detail-chronology.vue?vue&type=template&id=a5fca14c&"
import script from "./task-detail-chronology.vue?vue&type=script&lang=ts&"
export * from "./task-detail-chronology.vue?vue&type=script&lang=ts&"
import style0 from "./task-detail-chronology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports